
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/move-brasil",
      function () {
        return require("private-next-pages/move-brasil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/move-brasil"])
      });
    }
  